import { API_URL } from "../../../../../constants/index";
import { PostServiceCaller } from "../../../../../services/serviceCaller";

const schema = {
  Name: [{ rule: "required", message: "Name is required" }],
  DefaultContactID: [{ rule: "required", message: "Employee is required" }],
  // Description: [{ rule: "required", message: "Description is required" }],
  Username: [
    { rule: "required", message: "Username is required" },
    { rule: "email", message: "Please enter a valid email address" },
    { rule: "unique", message: "This username already exists" }
  ],
  Password: [
    { rule: "required", message: "Password is required" },
    { rule: "minLength", value: 8, message: "Password must be at least 8 characters" }
  ],
  txnPassword: [
    { rule: "required", message: "Confirm Password is required" },
    { 
      rule: "equalTo", 
      field: "Password", 
      message: "Passwords do not match" 
    }
  ],
  UserType_166: [{ rule: "required", message: "User Type is required" }],
  UserGroup_167: [{ rule: "required", message: "User Group is required" }],
  SessionTimeout: [
    { rule: "required", message: "Session Timeout is required" },
    { rule: "numeric", message: "Must be a number" },
    { rule: "min", value: 1, message: "Must be at least 1 minute" }
  ],
  roles: [
    { 
      rule: "requiredArray", 
      message: "At least one role is required",
      fields: ['role', 'company', 'branch', 'role_from_date'],
      messages: {
        role: "Role is required",
        company: "Company is required",
        branch: "Branch is required",
        role_from_date: "From Date is required"
      }
    }
  ]
};

const validate = async (name, value, formData) => {
  let error = { status: false, message: "" };
  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

  if (!schema[name]) return error;

  for (const validation of schema[name]) {
    switch (validation.rule) {
      case "required":
        if (!value || value.toString().trim() === "") {
          return { status: true, message: validation.message };
        }
        break;

      case "email":
        if (!emailRegex.test(value)) {
          return { status: true, message: validation.message };
        }
        break;

      case "unique":
        if (await checkUsername(value, formData)) {
          return { status: true, message: validation.message };
        }
        break;

      case "minLength":
        if (value.length < validation.value) {
          return { status: true, message: validation.message };
        }
        break;

      case "equalTo":
        if (value !== formData[validation.field || "Password"]) {
          return { status: true, message: validation.message };
        }
        break;

      case "numeric":
        if (isNaN(value)) {
          return { status: true, message: validation.message };
        }
        break;

      case "min":
        if (parseInt(value) < validation.value) {
          return { status: true, message: validation.message };
        }
        break;

      case "requiredArray":
        if (!value || value.length === 0) {
          return { status: true, message: validation.message };
        }
        
        // Validate each role entry
        for (let i = 0; i < value.length; i++) {
          const role = value[i];
          for (const field of validation.fields) {
            if (!role[field] || role[field] === "") {
              return { 
                status: true, 
                message: validation.messages[field],
                index: i,
                field: field
              };
            }
          }
        }
        break;

      default:
        break;
    }
  }

  return error;
};

async function checkUsername(username, formData) {
  try {
    const response = await PostServiceCaller(
      `${API_URL}check-user-exits/${formData?.ID || 0}`,
      { Username: username },
      "post"
    );
    return response?.data?.status !== "success";
  } catch (error) {
    console.error("Username check failed:", error);
    return true; // Assume username exists if check fails
  }
}

export default validate;